export default __webpack_public_path__ + "static/media/WMIS - loop_1.9f0632ad.wav";